import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PagesRoutingModule } from './pages-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';

// Plugins
import { DataTablesModule } from 'angular-datatables';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// import { BsDropdownModule } from 'ngx-bootstrap';
// import { DatepickerModule } from 'ngx-bootstrap';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { PopoverModule } from 'ngx-bootstrap/popover';

// import filepond module
import { FilePondModule, registerPlugin } from 'ngx-filepond';

// import and register filepond plugins
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileEncode from 'filepond-plugin-file-encode';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImageValidateSize from 'filepond-plugin-image-validate-size';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImageCrop from 'filepond-plugin-image-crop';
import FilePondPluginImageResize from 'filepond-plugin-image-resize';
import FilePondPluginImageTransform from 'filepond-plugin-image-transform';

import { ChartsModule } from 'ng2-charts';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { NgxSliderModule } from "@angular-slider/ngx-slider";

// Shared Components
import { NavigationComponent } from '../shared/header-navigation/navigation.component';
import { LeadsAlertsComponent } from './leads-alerts/leads-alerts.component';

registerPlugin(
  // encodes the file as base64 data
  FilePondPluginFileEncode,
  // validates files based on input type
  FilePondPluginFileValidateType,
  // Validate image size
  FilePondPluginImageValidateSize,
  // corrects mobile image orientation
  FilePondPluginImageExifOrientation,
	// previews the image
  FilePondPluginImagePreview,
	// crops the image to a certain aspect ratio
  FilePondPluginImageCrop,
	// resizes the image to fit a certain size
  FilePondPluginImageResize,
	// applies crop and resize information on the client
  FilePondPluginImageTransform
);

// Custom Pipes
import { ApplicationPipesModule } from '../services/pipes/application-pipes.module';

// Material Design Imports
import {
  // MatAutocompleteModule,
  // MatButtonModule,
  // MatButtonToggleModule,
  // MatCardModule,
  // MatCheckboxModule,
  // MatChipsModule,
  // MatDatepickerModule,
  // MatDialogModule,
  // MatExpansionModule,
  // MatGridListModule,
  // MatIconModule,
  // MatInputModule,
  // MatListModule,
  // MatMenuModule,
  // MatNativeDateModule,
  // MatProgressBarModule,
  // MatProgressSpinnerModule,
  MatRadioModule,
  // MatRippleModule,
  // MatSelectModule,
  // MatSidenavModule,
  // MatSliderModule,
  // MatSlideToggleModule,
  // MatSnackBarModule,
  // MatStepperModule,
  // MatTableModule,
  // MatTabsModule,
  // MatToolbarModule,
  // MatTooltipModule,
  // MatFormFieldModule,
} from '@angular/material';

// Pages
import { PageComponent } from './pages.component';
import { HomeComponent } from './SuperAdmin/home/home.component';
import { UnPaidOrderComponent } from './SuperAdmin/un-paid-order/un-paid-order.component';
import { OrderManagementComponent } from './SuperAdmin/order-management/order-management.component';
import { SalesAgentStatsComponent } from './SuperAdmin/sales-agent-stats/sales-agent-stats.component';
import { WriterPaymentComponent } from './SuperAdmin/writer-payment/writer-payment.component';
import { SalesHistoryComponent } from './SuperAdmin/sales-history/sales-history.component';
import { AISubscriptionsComponent } from './SuperAdmin/ai-subscriptions/ai-subscriptions.component';


// Shared
import { ManageTeamComponent } from './Shared/manage-team/manage-team.component';
import { AddUserComponent } from './Shared/add-user/add-user.component';
import { ModifyOrderComponent } from './Shared/modify-order/modify-order.component';
import { OrderDetailsComponent } from './Shared/order-details/order-details.component';
import { SearchOrdersComponent } from './Shared/search-orders/search-orders.component';
import { ManageProfileComponent } from './Shared/manage-profile/manage-profile.component';

import { WritersDashboardComponent } from './Writers/writers-dashboard/writers-dashboard.component';
import { ManageCustomersComponent } from './SuperAdmin/manage-customers/manage-customers.component';
import { CustomerOrdersComponent } from './SuperAdmin/customer-orders/customer-orders.component';
import { OrderClassificationComponent } from './SuperAdmin/order-classification/order-classification.component';
import { SignupsComponent } from './SuperAdmin/signups/signups.component';
import { AiSubscriptionLink } from './ai-subscription-link/ai-subscription-link.component';
import { ClosedOrdersComponent } from './SuperAdmin/closed-orders/closed-orders.component';
import { EmailPreviewComponent } from '../shared/email-preview/email-preview.component';
import { SignUpEmail1PreviewComponent } from '../shared/email-preview/signup-email-1/signup-email-1.component';
import { SignUpEmail2PreviewComponent } from '../shared/email-preview/signup-email-2/signup-email-2.component';
import { SignUpEmail3PreviewComponent } from '../shared/email-preview/signup-email-3/signup-email-3.component';
import { SignUpEmail4PreviewComponent } from '../shared/email-preview/signup-email-4/signup-email-4.component';
import { LeadEmail1PreviewComponent } from '../shared/email-preview/lead-email-1/lead-email-1.component';
import { LeadEmail2PreviewComponent } from '../shared/email-preview/lead-email-2/lead-email-2.component';
import { LeadEmail3PreviewComponent } from '../shared/email-preview/lead-email-3/lead-email-3.component';
import { LeadEmail4PreviewComponent } from '../shared/email-preview/lead-email-4/lead-email-4.component';
import { UpOrdersEmail2PreviewComponent } from '../shared/email-preview/up-orders-mail-2/up-orders-mail-2.component';
import { UpOrdersEmail3PreviewComponent } from '../shared/email-preview/up-orders-mail-3/up-orders-mail-3.component';
import { UpOrdersEmail4PreviewComponent } from '../shared/email-preview/up-orders-mail-4/up-orders-mail-4.component';
import { UserPackagesComponent } from './SuperAdmin/user-packages/user-packages.component';
@NgModule({
    imports: [
        CommonModule,
        PagesRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,

        NgbModule,
        DataTablesModule,
        FilePondModule,

        BsDatepickerModule.forRoot(),
        TimepickerModule.forRoot(),
        PopoverModule.forRoot(),
        // DatepickerModule.forRoot(),
        // DatetimePopupModule.forRoot(),
        MatRadioModule,

        // Custom Pipes Modules
        ApplicationPipesModule,
        NgSelectModule,
        ChartsModule,
        EditorModule,
        NgxSliderModule

    ],
    declarations: [
      NavigationComponent,
      LeadsAlertsComponent,
      PageComponent,
      HomeComponent,
      UnPaidOrderComponent,
      OrderManagementComponent,
      ManageTeamComponent,
      AddUserComponent,
      SalesAgentStatsComponent,
      ModifyOrderComponent,
      OrderDetailsComponent,
      SearchOrdersComponent,
      ManageProfileComponent,
      WritersDashboardComponent,
      WriterPaymentComponent,
      ManageCustomersComponent,
      CustomerOrdersComponent,
      OrderClassificationComponent,
      SalesHistoryComponent,
      AISubscriptionsComponent,
      SignupsComponent,
      AiSubscriptionLink,
      ClosedOrdersComponent,
      EmailPreviewComponent,
      SignUpEmail1PreviewComponent,
      SignUpEmail2PreviewComponent,
      SignUpEmail3PreviewComponent,
      SignUpEmail4PreviewComponent,
      LeadEmail1PreviewComponent,
      LeadEmail2PreviewComponent,
      LeadEmail3PreviewComponent,
      LeadEmail4PreviewComponent,
      UpOrdersEmail2PreviewComponent,
      UpOrdersEmail3PreviewComponent,
      UpOrdersEmail4PreviewComponent,
      UserPackagesComponent
    ]
})
export class PagesModule { }
